<template>
  <ProductsSectionTemplate
    divider
    title="Cestas de Chocolates"
    :loading="loading"
    :items="items"
  />
</template>

<script>
import ProductsSectionTemplate from "../templates/ProductsSectionTemplate.vue";
import { formatToURL } from "../../utils/formatToURL";

const _config = {
  mod: "products",
  path: "/produtos",
  itemsPerPage: 4,
  subcategoryId: 6,
};

export default {
  data: () => ({
    loading: true,
    items: [],
  }),
  created() {
    this.$rest(_config.mod)
      .get({
        params: {
          itemsPerPage: _config.itemsPerPage,
          subcategory: _config.subcategoryId,
        },
        save: (state, data) =>
          (this.items = data.map(
            ({ id, img, title, price, category, subcategory }) => ({
              img,
              title,
              price: price ? parseFloat(price) : 0,
              category,
              subcategory,
              to: `${_config.path}/${formatToURL(title)}-${id}`,
            })
          )),
      })
      .then(() => (this.loading = false));
  },
  components: {
    ProductsSectionTemplate,
  },
};
</script>
